import React, { useEffect, useState } from "react";
import "../supplierAndManufacturers.scss";
import { Menu, NoData } from "./ViewBody";
import ImageWithInitials from "../../../../Utils/ImageWithInitials";
import { CallToast } from "../../../PriceCalculator/modals/CustomToast";
import { useAuth } from "../../../context/Auth";
import { getAPIData } from "../../../../Utils/commonApi";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../constants/app.constants";
import integrationUtils from "../../../../Utils/integration.utils";
import ConnectedToolItem from "../../../stack/toolset-selection/browse-by-technology/connected-tool-item.component";
import { API_DOMENS } from "../../../../constants/apis.constants";

const TYPES = [{
  id: 0,
  label: 'Tool'
},
{
  id: 1,
  label: 'Product'
},
{
  id: 2,
  label: 'Service'
},
{
  id: 3,
  label: 'Package'
},
{
  id: 4,
  label: 'Storefront products'
},
]

const ToolsData = [{
  name: 'Endpoint Protection',
},
{
  name: 'Email Filtering',
}]

const ProductsData = [{
  name: 'Product 1',
  description: 'CyberSecurity • Cloud Base • £80'
},
{
  name: 'Product B',
  description: 'CyberSecurity • Cloud Base • £80'
},
{
  name: 'Product 1',
  description: 'CyberSecurity • Cloud Base • £80'
}]

const ServicesData = [{
  name: 'Advanced Email Protection',
  description: 'Service • Cost • £2.28/user/month • Sell • £4.00/user/month '
},
{
  name: 'Dark Web Monitoring',
  description: 'Service • Cost • £2.28/user/month • Sell • £4.00/user/month '
},
{
  name: 'Endpoint Detection',
  description: 'Service • Cost • £2.28/user/month • Sell • £4.00/user/month '
}]

const PackagesData = [{
  name: 'Advanced Email Protection',
  description: 'Service • Cost • £2.28/user/month • Sell • £4.00/user/month '
}]

const DataBlock = ({ selectedMenuItem = Menu[0], data = {}, itemId = 0, isSupplier = false }) => {
  const { authTokens } = useAuth();
  const [associationsData, setAssociationsData] = useState({});

  useEffect(() => {
    getAssociations();
  }, [])

  async function getAssociations() {
    return new Promise((resolve, reject) => {
      getAPIData(1082, authTokens, {
        optionEnum1: itemId,
        optionEnum2: isSupplier ? 0 : 1
      }, API_DOMENS.CC_API)
        .then((response) => {
          if (response?.mr?.Success) {
            setAssociationsData(response);
          } else {
            CallToast("Something went wrong", false, false, "v2style");
          }
        })
        .catch((error) => {
          reject(error);
          CallToast("Something went wrong", false, false, "v2style");
        });
    });
  }


  return (
    <>
      <div className="blockData">
        {
          (selectedMenuItem?.id == 0 ? associationsData?.Tool_List : selectedMenuItem?.id == 1 ?
            associationsData?.Product_List : selectedMenuItem?.id == 2 ? associationsData?.Service_List : selectedMenuItem?.id == 3 ? associationsData?.Package_List : associationsData?.StoreFrontProduct_List)?.length > 0 ? <>
            {
              (selectedMenuItem?.id == 0 ? associationsData?.Tool_List : selectedMenuItem?.id == 1 ?
                associationsData?.Product_List : selectedMenuItem?.id == 2 ? associationsData?.Service_List : selectedMenuItem?.id == 3 ? associationsData?.Package_List : associationsData?.StoreFrontProduct_List
              )?.map((dataItem) => {
                return (
                  <DataItem
                    name={selectedMenuItem?.id == 0 ? dataItem?.TechnologyName : dataItem?.Name}
                    description={dataItem?.Description}
                    icon={selectedMenuItem?.id == 0 ? '' : selectedMenuItem?.id == 1 ? '/images/settings-nav/product_icon.svg' : selectedMenuItem?.id == 2 ? '/images/msp/msp-package-icon.svg' : '/images/msp/package-icon.svg'}
                    children={selectedMenuItem?.id == 0 && /*<ToolChildren icon={dataItem?.ToolIcon} name={dataItem?.ToolName}*/ <ConnectedToolItem
                      key={`connected-tool-${dataItem?.ToolName}`}
                      tool={dataItem}
                      passedIdKey={'ObjectId'}
                      passedStyle={'w-fit-content justify-content-end'}
                    />}
                    type={TYPES[selectedMenuItem?.id]}
                    id={selectedMenuItem?.id == 0 ? dataItem?.TechnologyName : dataItem?.ObjectId}
                  />
                )
              })
            }
          </> : <NoData />
        }
      </div>
      {selectedMenuItem?.id == 0 && <DetailsBlock name={data?.CreatedBy} icon={data?.CreatedByImage} createdAt={data?.CreatedAt} lastActivity={data?.LastActivity} timeAgo={data?.TimeAgo} />}
    </>
  );
};

export default DataBlock;

const DataItem = ({
  icon = '',
  name = '',
  description = '',
  children,
  type = {},
  id = 0
}) => {
  const navigate = useNavigate();
  return (
    <div className="blockDataItem pointer" onClick={() => {
      if (type?.id == TYPES[0]?.id) {
        navigate(ROUTE_PATHS.mspv2.securityStack, { state: { selectedId: id } });
      } else if (type?.id == TYPES[1]?.id) {
        navigate(ROUTE_PATHS.mspv2.sellProducts, { state: { selectedId: id } });
      } else if (type?.id == TYPES[2]?.id) {
        navigate(ROUTE_PATHS.mspv2.sellServices, { state: { selectedId: id } });
      } else if (type?.id == TYPES[3]?.id) {
        navigate(ROUTE_PATHS.mspv2.priceCalculator(id));
      }
    }}>
      <div className="d-flex align-items-center">
        {icon != '' && <img src={icon} width={19} height={19} alt="data icon" className="mr-2" />}
        <div>
          <div className="name">{name}</div>
          {children ? children : <div className="description">{description}</div>}
        </div>
      </div>
      <img src={'/images/supply-chain/redirect-icon.svg'} width={12} height={12} alt="redirect icon" className="pointer" onClick={() => {
        if (type?.id == TYPES[0]?.id) {
          navigate(ROUTE_PATHS.mspv2.securityStack, { state: { selectedId: id } });
        } else if (type?.id == TYPES[1]?.id) {
          navigate(ROUTE_PATHS.mspv2.sellProducts, { state: { selectedId: id } });
        } else if (type?.id == TYPES[2]?.id) {
          navigate(ROUTE_PATHS.mspv2.sellServices, { state: { selectedId: id } });
        } else if (type?.id == TYPES[3]?.id) {
          navigate(ROUTE_PATHS.mspv2.priceCalculator(id));
        }
      }} />
    </div>
  )
}

const ToolChildren = ({
  icon,
  name = ''
}) => (
  <div className="toolItem">
    {icon && <img src={icon} width={16} height={16} alt="tool logo" className="rounded-full mr-2" />}
    <div>{name}</div>
  </div>
)

const DetailsBlock = ({
  name = '',
  icon,
  createdAt = '',
  lastActivity = '',
  timeAgo = ''
}) => (
  <div className="detailsBlock">
    <div className="headerLabel"> Details</div>
    <DetailItem label={'Created by'} children={<div className="d-flex align-items-center">
      {!icon ? (
        <ImageWithInitials initials={name ? name?.charAt(0) : ''} width={16} background={"purple"} />
      ) : (
        <img
          alt=""
          src={/^\d+$/.test(icon) ? integrationUtils.getImagePath(icon) : icon}
          style={{ width: "16px", height: "16px", borderRadius: "10px", objectFit: "contain", }}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = "/images/settings-v2/highground-dp.svg";
          }}
        />
      )}
      <div className="data ml-2">{name}</div>
    </div>} />
    <DetailItem label={'Created at'} data={createdAt} />
    <DetailItem
      label={'Last Activity'}
      children={<div className="lastActivity">
        <div>{lastActivity}</div>
        <div className="dataTime">{lastActivity && timeAgo}</div>
      </div>}
    />
  </div >
)

const DetailItem = ({
  label = '',
  data = '',
  children,
}) => (
  <div className={`d-flex align-items-start justify-content-between`}>
    <div className="label">{label}</div>
    {children ? children : <div className="data">{data}</div>}
  </div>
) 